import { type PageChangeSummary, type PublicationSummary } from "api/api-types-publishing";
import type { PageType } from "components/server-types";

export const splitSummaryBySubmissions = (
  summary: PublicationSummary,
  storePages: Record<string, PageType>,
): { filteredSummary: PublicationSummary; pagesWithSubmissions: PageChangeSummary[] } => {
  const hasSubmissions = (page: PageChangeSummary) =>
    Boolean(storePages[page.id]?.has_linked_submissions);

  const allPages = [
    ...summary.topics.flatMap((t) => [
      ...t.prep_pages,
      ...t.lesson_pages,
      ...t.resource_pages,
      ...t.archive_pages,
    ]),
    ...summary.assignments,
    ...summary.resources,
    ...summary.workspaces,
  ];

  const submissionPageIds = new Set(allPages.filter(hasSubmissions).map((p) => p.id));
  const exclude = (pages: PageChangeSummary[]) => pages.filter((p) => !submissionPageIds.has(p.id));

  return {
    filteredSummary: {
      ...summary,
      topics: summary.topics.map((topic) => ({
        ...topic,
        prep_pages: exclude(topic.prep_pages),
        lesson_pages: exclude(topic.lesson_pages),
        resource_pages: exclude(topic.resource_pages),
        archive_pages: exclude(topic.archive_pages),
      })),
      assignments: exclude(summary.assignments),
      resources: exclude(summary.resources),
      workspaces: exclude(summary.workspaces),
    },
    pagesWithSubmissions: allPages.filter((p) => submissionPageIds.has(p.id)),
  };
};
